import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=e0b367d0&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/65379/11/MultiSearchOS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0b367d0')) {
      api.createRecord('e0b367d0', component.options)
    } else {
      api.reload('e0b367d0', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=e0b367d0&", function () {
      api.rerender('e0b367d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/Notifications.vue"
export default component.exports